import { IMeta, IPagination, ISort } from "@delanobgt/admin-core/util/types";
import { produce } from "immer";
import { Reducer } from "redux";
import {
  EReferralRewardSortField,
  IReferralReward,
  PReferralRewardFilter,
} from "src/core/referralReward/entities";
import { ActionType, createAction, getType } from "typesafe-actions";

/*
 * state
 */
export interface IReferralRewardState {
  referralRewards: IReferralReward[];
  loading: boolean;
  error: any;
  meta: IMeta;
}

const initialState: IReferralRewardState = {
  referralRewards: [],
  loading: false,
  error: null,
  meta: {
    limit: 10,
    offset: 0,
    total: 0,
  },
};

/*
 * action types
 */
const FETCH_REQUESTED = "referral-reward/FETCH_REQUESTED";
const FETCH_SUCCEEDED = "referral-reward/FETCH_SUCCEEDED";
const FETCH_FAILED = "referral-reward/FETCH_FAILED";
const POLLING_START_REQUESTED = "referral-reward/POLLING_START_REQUESTED";
const POLLING_STOP_REQUESTED = "referral-reward/POLLING_STOP_REQUESTED";

/*
 * action creators
 */
export const actions = {
  fetchRequested: createAction(FETCH_REQUESTED)(),

  fetchSucceeded: createAction(FETCH_SUCCEEDED)<{
    data: IReferralReward[];
    meta: IMeta;
  }>(),

  fetchFailed: createAction(FETCH_FAILED)<any>(),

  pollingStartRequested: createAction(POLLING_START_REQUESTED)<{
    userId: number;
    filter: PReferralRewardFilter;
    pagination: IPagination;
    sorts: ISort<EReferralRewardSortField>[];
    refreshDelay: number;
  }>(),

  pollingStopRequested: createAction(POLLING_STOP_REQUESTED)(),
};
export type TActions = ActionType<typeof actions>;

const reducer: Reducer<IReferralRewardState, TActions> = (
  state = initialState,
  action
) => {
  return produce<IReferralRewardState>(state, (draft) => {
    switch (action.type) {
      case getType(actions.fetchRequested): {
        draft.loading = true;
        draft.error = null;
        break;
      }
      case getType(actions.fetchSucceeded): {
        const {
          payload: { data, meta },
        } = action;
        draft.referralRewards = data;
        draft.loading = false;
        draft.error = null;
        draft.meta = meta;
        break;
      }
      case getType(actions.fetchFailed): {
        const { payload } = action;
        draft.loading = false;
        draft.error = payload;
        break;
      }
    }
  });
};

export default reducer;
